module.exports = flarum.core.compat['components/PermissionGrid'];